





















import type { PropType } from '@vue/composition-api';
import { computed, watch, ref, defineComponent } from '@vue/composition-api';
import type { EditorBlock } from '@getaccept/editor-lib';
import { ContractHelper } from '@getaccept/editor-lib';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import SectionList from './SectionList.vue';

export default defineComponent({
  name: 'BlockListItem',
  components: {
    SectionList,
    NameInput,
  },
  props: {
    block: {
      type: Object as PropType<EditorBlock>,
      required: true,
    },
    isCurrentBlock: {
      type: Boolean,
      default: false,
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: null,
    },
  },
  setup(props) {
    const sectionsOpen = ref(false);
    const nameInputValue = ref(props.block.content.displayName || t('untitled_page'));

    watch(
      () => props.isCurrentBlock,
      () => {
        if (props.isCurrentBlock) {
          sectionsOpen.value = true;
        }
      },
      { immediate: true }
    );

    const toggleSections = () => {
      sectionsOpen.value = !sectionsOpen.value;
    };

    const filteredSections = computed(() =>
      ContractHelper.filterSectionsByContractLinkAccess(
        props.block.content.sections,
        props.recipient
      )
    );

    const visibleSections = computed(() => filteredSections.value.filter(({ hidden }) => !hidden));

    return {
      sectionsOpen,
      toggleSections,
      nameInputValue,
      visibleSections,
      filteredSections,
    };
  },
});
